import { render, staticRenderFns } from "./BrokerLogsTab.vue?vue&type=template&id=e3abc4c2&"
import script from "./BrokerLogsTab.vue?vue&type=script&lang=ts&"
export * from "./BrokerLogsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports